export const MARK_AS_READ = 'MARK_AS_READ'
export const UPDATE_PERFORMED = 'UPDATE_PERFORMED'
export const SET_NEW_CHANGELOG = 'SET_NEW_CHANGELOG'
